<div class="row">
  @for (stateLocation of locations; track stateLocation; let i = $index) {
    <div class="col-lg-4 col-md-12">
      <h3>
        {{stateLocation[0].state}}
      </h3>
      <ul class="list-unstyled">
        @for (location of stateLocation; track location; let j = $index) {
          <li>
            <a tabindex="0" id="centerDetails{{panelID}}{{i}}{{j}}" (click)="popover.toggle(); togglePopover(location)" (focus)="popover.hide()"
              (keyup.enter)="popover.toggle(); togglePopover(location)" (keyup.spacebar)="popover.toggle(); togglePopover(location)" class="centerDetails">
              <strong>{{location.city}} @if (location.shortName.length > 0) {
                <span>({{location.shortName}})</span>
              }</strong>
            </a>
            <app-popover [id]="'popover' + panelID + i + j" [position]="getPosition(i)" (onClosed)="handleClosed('centerDetails' + panelID + i + j)" #popover>
              <h3 class="popover-title">{{location.name}}</h3>
              <div class="popover-content">
                <p class="centerAddress">
                  {{location.address}}, {{location.city}}, {{location.state}} {{location.postalCode}}
                </p>
                @if (viewOnly) {
                  <a [href]="getGoogleAddress(location)" title="{{'SCHEDULE_INTERVIEW.LOCATION.POPOVER.GOOGLE_MAPS_TITLE' | translate:{value: location.name} }}" target="_blank" rel="noopener noreferrer" class="mapLink" (keydown.tab)="popover.hide()">
                    <span translate>SCHEDULE_INTERVIEW.LOCATION.POPOVER.googleMaps</span> <i class="fa fa-external-link"></i>
                  </a>
                }
                @if (!viewOnly && !availableDate) {
                  <a [href]="getGoogleAddress(location)" title="{{'SCHEDULE_INTERVIEW.LOCATION.POPOVER.GOOGLE_MAPS_TITLE' | translate:{value: location.name} }}" target="_blank" rel="noopener noreferrer" class="mapLink" (keydown.tab)="popover.hide()">
                    <span translate>SCHEDULE_INTERVIEW.LOCATION.POPOVER.googleMaps</span> <i class="fa fa-external-link"></i>
                  </a>
                }
                @if (!viewOnly && availableDate) {
                  <a [href]="getGoogleAddress(location)" title="{{'SCHEDULE_INTERVIEW.LOCATION.POPOVER.GOOGLE_MAPS_TITLE' | translate:{value: location.name} }}" target="_blank" rel="noopener noreferrer" class="mapLink">
                    <span translate>SCHEDULE_INTERVIEW.LOCATION.POPOVER.googleMaps</span> <i class="fa fa-external-link"></i>
                  </a>
                }
                @if (popover.isVisible && availableDate) {
                  <div class="nextAppointment">
                    <strong translate>SCHEDULE_INTERVIEW.LOCATION.POPOVER.nextAppt</strong>:
                    <span class="date"><span id="monthSpan" translate>{{availableMonth}}</span> {{availableDate | date: 'd, y'}}</span>
                  </div>
                }
                @if (popover.isVisible && !availableDate && !lastPublishedDate) {
                  <div class="nextAppointment">
                    <strong translate>SCHEDULE_INTERVIEW.LOCATION.POPOVER.noneAvailable</strong>
                  </div>
                }
                @if (popover.isVisible && !availableDate && lastPublishedDate) {
                  <div class="nextAppointment">
                    <strong translate>SCHEDULE_INTERVIEW.LOCATION.POPOVER.lastPublished</strong>:
                    <span class="date"><span id="lastPubMonthSpan" translate>{{lastPublishedMonth}}</span> {{lastPublishedDate | date: 'd, y'}}</span>
                  </div>
                }
                @if (!viewOnly && availableDate !== null) {
                  <div class="actionRow">
                    <button id="btnChooseLocation" class="btn btn-primary"
                      (click)="locationSelected.emit(location)"
                      (keyup.enter)="locationSelected.emit(location)"
                      (keyup.spacebar)="locationSelected.emit(location)"
                      (keydown.tab)="popover.hide()"><span translate>SCHEDULE_INTERVIEW.LOCATION.POPOVER.chooseLocation</span></button>
                      <sub [innerHTML]="'SCHEDULE_INTERVIEW.LOCATION.POPOVER.save' | translate"></sub>
                    </div>
                  }
                </div>
              </app-popover>
            </li>
          }
        </ul>
      </div>
    }
  </div>